export const AutoplayInterval = 20000;
